export const DEAL_SUMMARY_DOCUMENTS = {
  APPLICATION: 'application',
  NON_APPLICANT_DISCLOSURE: 'non-applicant-disclosure',
  INVESTMENT_ESTIMATE: 'investment-estimate',
  CLOSING_STATEMENT: 'closing-statement',
  DOC_DRAW_BETA: 'doc-draw-beta',
  DSCR_OVERVIEW: 'dscr-overview',
  DTI_OVERVIEW: 'dti-overview',
  SAMPLE_CONTRACT_DOCS: 'sample-contract-docs',
}

export const THIRD_PARTY_REPORTS = {
  APPRAISAL_REPORT: 'appraisal-report',
  AVM_REPORT: 'avm-report',
  CREDIT_REPORT: 'credit-report',
  PROPERTY_DETAILS: 'property-details',
  PRELIMINARY_FLOOD_ZONE_CERT: 'preliminary-flood-zone-cert',
  LIFE_OF_LOAN_FLOOD_ZONE_CERT: 'life-of-loan-flood-zone-cert',
  TITLE_REPORT: 'title-report',
}
